import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0,
    page:1,
    olddata:[]
   
    
}

const mutations={
   
    
    
    
    getShopCartData(state,val){
        

     
        post(urls.admin.shop_cart.index,val).then((result)=>{
          
          
          
          state.result=result
          state.olddata=result
          
       
       
        
       
           
        });
        
    },

    addShopCartOrder(state,val){
        
        post(urls.admin.shop_cart.add,val).then((result)=>{
          
          
          
            // state.result=result
           
             state.result= result
         
         
          
         
             
          });
    }
   
   
   
}
const  actions={
    getShopCartDataAction(context,value){
        
        context.commit("getShopCartData",value)
       
    },
    addShopCartOrderAction(context,value){
        
        context.commit("addShopCartOrder",value)
       
    }
    
  
   
    
   
  
    
  
    
   

}

export default {state,mutations,actions}